<template>
  <div class="hvh-card--rounded v-sheet theme--light">
    <div class="pl-4 mb-3" style="display: flex; justify-content: space-between" v-if="!showSearch">
      <h2 class="pt-2">
        <template v-if="text">{{ text + menuOptionText }}</template>
      </h2>
      <div v-if="menuOptions">
        <v-menu v-model="menu" bottom left origin="top right" style="z-index: 1001">
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="my-1 mx-2" flat icon v-bind="attrs" v-on="on" @click.stop.prevent>
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <div @click.stop @mousedown.stop @mouseup.stop v-if="(allChartTypes || []).length">
            <v-select :value="menuOptions.prop" :items="allChartTypes" label="Chart type" placeholder="Select an event..." @input="(skipNextFilter = true), $emit('top-event-changed', $event)" outline hide-details />
          </div>
          <v-card class="py-1">
            <v-list class="pb-0">
              <v-list-tile class="search" @click="(showSearch = true), (menu = false)">
                <v-flex class="icon">
                  <v-btn class="button" flat icon>
                    <v-icon medium>mdi-magnify</v-icon>
                  </v-btn>
                </v-flex>
                <v-list-tile-title>Search</v-list-tile-title>
              </v-list-tile>
            </v-list>

            <template>
              <v-divider></v-divider>
              <v-list class="pb-0">
                <v-list-tile>
                  <v-list-tile-sub-title>Sort Order</v-list-tile-sub-title>
                </v-list-tile>
              </v-list>

              <v-list class="py-0">
                <v-list-tile @click="setUsePatientCount(false)">
                  <v-flex style="min-width: 40px">
                    <v-icon v-if="!menuOptions.usePatientCount">mdi-check</v-icon>
                  </v-flex>
                  <v-list-tile-title>HCPs</v-list-tile-title>
                </v-list-tile>
              </v-list>

              <v-list class="py-0">
                <v-list-tile @click="setUsePatientCount(true)">
                  <v-flex style="min-width: 40px">
                    <v-icon v-if="menuOptions.usePatientCount">mdi-check</v-icon>
                  </v-flex>
                  <v-list-tile-title>Patients</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </template>
            <template v-if="(menuOptions.levels || []).length">
              <v-divider></v-divider>
              <v-list class="pb-0">
                <v-list-tile>
                  <v-list-tile-sub-title>Select level of detail for chart</v-list-tile-sub-title>
                </v-list-tile>
              </v-list>

              <v-list class="py-0">
                <v-list-tile v-for="(option, ind) in menuOptions.levels" @[clickOption(option)]="selectOption('levels', option)" :key="ind + option.text">
                  <v-flex style="min-width: 40px">
                    <v-icon v-if="option.selected">mdi-check</v-icon>
                  </v-flex>
                  <v-icon style="transform: rotateY(180deg)" :style="{ 'margin-left': (ind - 1) * 32 + 'px' }" v-if="ind > 0">mdi-keyboard-return</v-icon>
                  <v-list-tile-title :class="{ 'ml-2': ind }">{{ option.text }}</v-list-tile-title>
                </v-list-tile>
              </v-list>

              <v-divider></v-divider>
              <v-list class="pb-0">
                <v-list-tile>
                  <v-list-tile-sub-title>Select an option</v-list-tile-sub-title>
                </v-list-tile>
              </v-list>

              <v-list class="py-0">
                <v-list-tile v-for="(option, ind) in menuOptions.options" @[clickOption(option)]="selectOption('options', option)" :key="ind + option.text">
                  <v-flex style="min-width: 40px">
                    <v-icon v-if="option.selected">mdi-check</v-icon>
                  </v-flex>
                  <v-list-tile-title>{{ option.text }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </template>
          </v-card>
        </v-menu>
      </div>
    </div>
    <!-- <hvh-chart :visualization="visualization" :options="chartOptions" :isEditMode="true" @item-clicked="$emit('checked-changed', $event, sortedData)" @wheel="scroll" ref="chart" /> -->
    <SearchableHorizontalBarchartFilter
      :text="text + menuOptionText"
      :bottomText="menuOptions.usePatientCount ? 'Patients' : 'HCPs'"
      :data="data"
      :options="options"
      nameField="diagnosis"
      :valueField="menuOptions.usePatientCount ? 'patientCount' : 'hcpCount'"
      :isChecked="isChecked"
      :showSearch.sync="showSearch"
      :showLoader="isFiltering"
      @checked-changed="$emit('checked-changed', $event)"
    />
  </div>
</template>
  
<script>
import { customNumberFormat, Debouncer, hashCode, } from '../../../../libraries/common';
import SearchableHorizontalBarchartFilter from '../../../analysis/SearchableHorizontalBarchartFilter.vue';
export default {
  components: { SearchableHorizontalBarchartFilter },
  props: ['data', 'filterObject', 'text', 'isChecked', 'isFiltering', 'menuOptions', 'allChartTypes',],
  data() {
    return {
      debouncer: new Debouncer(2000),
      search: {},
      showSearch: false,
      menu: false,
      skipNextFilter: false,
      options: {
        tooltip: {
          formatter: (params) => {
            var marker = '<dt style="width:10px;height:10px;display:inline-block;margin-right:5px;">' +
              '<svg viewBox="0 0 12 12"><path fill="' + params.color + '" d="M0 0h12v12H0z"></path></svg>' +
              '</dt>';

            return '<div style="max-width:400px;white-space:pre-wrap;">' +
              params.name + '<br>' +
              marker + ' HCPs: ' + customNumberFormat(params.data.data.hcpCount) + '<br>' +
              marker + ' Patients: ' + customNumberFormat(params.data.data.patientCount) + '<br>' +
              '<div>';
          }
        },
      },
    }
  },
  methods: {
    clickOption(option) {
      return !option.selected ? 'click' : null;
    },
    selectOption(prop, option) {
      this.$emit('update:menu-options', {
        ...this.menuOptions,
        [prop]: this.menuOptions[prop].map(f => ({ ...f, selected: f === option }))
      });
      this.skipNextFilter = true;
      this.$nextTick(() => this.$emit('load-data', this.filterObject));
    },
    setUsePatientCount(usePatientCount) {
      this.$emit('update:menu-options', { ...this.menuOptions, usePatientCount });
    },
  },
  computed: {
    filterHash() {
      return hashCode(this.filterObject || {});
    },
    menuOptionText() {
      if (!this.menuOptions.levels) return '';
      var menuOptionText = (this.menuOptions.levels.find(f => f.selected) || {}).text;
      if (!menuOptionText) return '';
      return `: ${menuOptionText.split('/')[0]}`;
    },
  },
  watch: {
    filterHash() {
      if (!this.skipNextFilter) {
        this.debouncer.clear().push(() => this.$emit('refresh-data', this.filterObject));
      } else {
        this.skipNextFilter = false;
      }
    },
  },
  mounted() {
    this.$emit('chart-created', this.filterObject);
  }
}
</script>

<style lang="scss" scoped>
.search {
  min-width: 150px;
  .icon {
    min-width: 40px;
    .button {
      margin-left: -6px;
    }
  }
}
</style>